// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"e0f52f6a","456":"5b1c23e7","988":"a63bd575"}[chunkId] + ".chunk.css";
};